export default __webpack_public_path__ + "static/media/default.ecc0af81.svg";